import { RuleSetSchema } from "@automatry/schemas";
import { CREATED_AT, ORG_ID, RULE_SET_ID, RULE_SET_VERSION, SOURCE_REFS, openQuestions, ruleCards } from "./sourceAuthority.js";
import { loadProfiles } from "./loadProfiles.js";
export * from "./sourceAuthority.js";
export * from "./loadProfiles.js";
export * from "./controllerSelection.js";
export * from "./screenRules.js";
export * from "./infrastructureRules.js";
const ruleSet = {
    id: RULE_SET_ID,
    orgId: ORG_ID,
    version: RULE_SET_VERSION,
    name: "Baseline Titan controls rules, January 2026 seed",
    status: "draft",
    ruleCards,
    openQuestions: openQuestions.map(({ defaultDisposition: _defaultDisposition, ...question }) => question),
    loadProfiles,
    sourceRefs: [
        SOURCE_REFS.baselineRules,
        SOURCE_REFS.methodologyDecisions,
        SOURCE_REFS.rulesEncodingPlan
    ],
    createdAt: CREATED_AT
};
export const baseline2026RuleSet = RuleSetSchema.parse(ruleSet);
//# sourceMappingURL=index.js.map